import { ref } from 'vue'

export interface AppConfig {
	appStage: 'DEV' | 'NIGHTLY' | 'STAGE' | 'PRODUCTION'
	appVersion: string

	baseUrl: string

	apiServer: string
	apiServerDefaultVersion: string | false

	sentryDSN: Nullable<string>

	contactNumber: Nullable<string>
	formattedContactNumber: Nullable<string>
}

const requiredEnvVariables = [
	'VITE_APP_STAGE',
	'VITE_APP_VERSION',
	'VITE_BASE_URL',
	'VITE_SSL_ENABLED',
	'VITE_API_SERVER'
]

const config = ref<Nullable<AppConfig>>(null)

export function useAppConfig(): AppConfig {
	if (config.value) {
		return config.value
	}

	requiredEnvVariables.forEach((variable) => {
		if (!import.meta.env[variable]) {
			throw new Error(`[AppConfig] '${variable}' is not defined`)
		}
	})

	if (
		!['DEV', 'NIGHTLY', 'STAGE', 'PRODUCTION'].includes(
			import.meta.env.VITE_APP_STAGE
		)
	) {
		throw new Error(
			`[ApiConfig] unknown app stage '${import.meta.env.VITE_APP_STAGE}'!`
		)
	}

	const schema =
		import.meta.env.VITE_SSL_ENABLED === 'true' ? 'https://' : 'http://'
	config.value = {
		appStage: import.meta.env.VITE_APP_STAGE,
		appVersion: import.meta.env.VITE_APP_VERSION,
		baseUrl: import.meta.env.VITE_BASE_URL,

		apiServer: `${schema}${import.meta.env.VITE_API_SERVER}`,
		apiServerDefaultVersion:
			import.meta.env.VITE_API_SERVER_DEFAULT_VERSION || false,

		contactNumber: import.meta.env.VITE_APP_CONTACT_NUMBER || null,
		formattedContactNumber:
			import.meta.env.VITE_APP_FORMATTED_CONTACT_NUMBER || null,

		sentryDSN: import.meta.env.VITE_SENTRY_DSN || null
	}

	return config.value
}
